import { Box, MenuItem, Typography } from "@mui/material";
import { isNonEmptyArray, isNonEmptyString } from "@/utils";
import { sxFont_32_500 } from "@/theme";

export class MuiHelper {
  static getMenuItems = (
    data?: { [key: string]: any }[],
    propertyNameValue?: string,
    propertyNameText?: string
  ) =>
    isNonEmptyArray(data) &&
      isNonEmptyString(propertyNameValue) &&
      isNonEmptyString(propertyNameText)
      ? data?.map((item) => (
        <MenuItem
          key={item?.[propertyNameValue!]}
          value={item?.[propertyNameValue!]}
        >
          {item?.[propertyNameText!]}
        </MenuItem>
      ))
      : undefined;

  static getHeader = (text?: string, startIcon?: React.ReactNode,endIcon?:React.ReactNode) => (
    <Box sx={{display:"flex",gap:1,alignItems:"center"}}>
      {startIcon}
      <Typography
        variant="h6"
        component="div"
        sx={{ flexGrow: 1, ...sxFont_32_500 }}
      >
        {text}
      </Typography>
      {endIcon}
    </Box>
  );

  static getCenteredImage = (
    src?: string,
    alt?: string,
    title?: string,
    width?: string,
    height?: string
  ) => (
    <Box
      sx={{
        width: "auto",
        height: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {isNonEmptyString(src) ? (
        <img
          src={src}
          alt={alt}
          title={title}
          loading="lazy"
          style={{
            width: width || "100%",
            height: height || "auto",
            objectFit: "cover",
          }}
        />
      ) : undefined}
    </Box>
  );
}
